import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderStatuses } from 'entities/Order/model/consts/orderStatuses';

import { ChangeOrderStatusButton } from './ChangeOrderStatusButton';

interface PlaceOrderButtonProps {
    orderId: string;
    isNoItemsInOrder: boolean;
    isRequiredPoNumberForOrder: boolean;
    hasLoadingPnA: boolean;
}

export const ApproveOrderButton = memo(
    ({
        orderId,
        isNoItemsInOrder,
        isRequiredPoNumberForOrder,
        hasLoadingPnA,
    }: PlaceOrderButtonProps) => {
        const { t } = useTranslation();

        return (
            <ChangeOrderStatusButton
                newStatus={OrderStatuses.APPROVED}
                orderId={orderId}
                messageOnSuccess={t('Order submitted to supplier(s)')}
                variant="contained"
                disabled={
                    isNoItemsInOrder ||
                    isRequiredPoNumberForOrder ||
                    hasLoadingPnA
                }
                isRequiredPoNumberForOrder={isRequiredPoNumberForOrder}
            >
                {isRequiredPoNumberForOrder
                    ? t('PO required')
                    : t('Submit order')}
            </ChangeOrderStatusButton>
        );
    },
);
